<template>
  <div>
    <nav-bar type="dark"></nav-bar>
    <form-venda />
  </div>

</template>
<script>

import NavBar from "./NavBar/NavBar.vue";
import FormVenda from "./campaigns/FormVenda.vue";

export default {
  name: 'Saler',

  components: {
    NavBar,
    FormVenda
  },

  mounted() {
    if (!this.$store.state.user.token) {
      this.$router.push("/");
    }
  },

  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// Sale.vue?da18d36e